/**
 * The Man Himself — auto-sliding image block
 * Handles: autoplay, dot navigation, pause on hover/focus,
 * touch swipe, and re-init on Shopify section reload (theme editor).
 */

(function () {
  class ManHimselfSlider {
    constructor(sliderEl) {
      this.slider = sliderEl;
      this.sectionEl = sliderEl.closest('.man-himself-section');
      this.track = sliderEl.querySelector('.mh-slider-track');
      this.slides = Array.from(sliderEl.querySelectorAll('.mh-slide'));
      this.dots = Array.from(sliderEl.querySelectorAll('.mh-dot'));
      this.currentIndex = 0;
      this.timer = null;
      this.isPaused = false;

      this.autoplay = this.sectionEl?.dataset.autoplay === 'true';
      this.speed = parseInt(this.sectionEl?.dataset.autoplaySpeed, 10) || 4000;

      if (this.slides.length <= 1) return;

      this.bindEvents();
      if (this.autoplay) this.start();
    }

    goTo(index) {
      if (index === this.currentIndex) return;
      this.slides[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex]?.classList.remove('is-active');

      this.currentIndex = (index + this.slides.length) % this.slides.length;

      this.slides[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex]?.classList.add('is-active');
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => {
        if (!this.isPaused) this.next();
      }, this.speed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    bindEvents() {
      // Dot navigation
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.goTo(i);
          if (this.autoplay) this.start(); // reset timer on manual nav
        });
      });

      // Pause on hover / focus (desktop)
      this.slider.addEventListener('mouseenter', () => (this.isPaused = true));
      this.slider.addEventListener('mouseleave', () => (this.isPaused = false));
      this.slider.addEventListener('focusin', () => (this.isPaused = true));
      this.slider.addEventListener('focusout', () => (this.isPaused = false));

      // Swipe support (mobile)
      let startX = 0;
      let isSwiping = false;

      this.track.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          isSwiping = true;
          this.isPaused = true;
        },
        { passive: true }
      );

      this.track.addEventListener(
        'touchend',
        (e) => {
          if (!isSwiping) return;
          const endX = e.changedTouches[0].clientX;
          const diff = startX - endX;
          const threshold = 40;

          if (diff > threshold) {
            this.next();
          } else if (diff < -threshold) {
            this.prev();
          }
          isSwiping = false;
          this.isPaused = false;
          if (this.autoplay) this.start();
        },
        { passive: true }
      );

      // Pause when tab is not visible
      document.addEventListener('visibilitychange', () => {
        this.isPaused = document.hidden;
      });
    }

    destroy() {
      this.stop();
    }
  }

  function initSliders(container) {
    const scope = container || document;
    scope.querySelectorAll('.mh-slider').forEach((sliderEl) => {
      if (sliderEl.dataset.mhInitialized) return;
      sliderEl.dataset.mhInitialized = 'true';
      sliderEl.mhInstance = new ManHimselfSlider(sliderEl);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initSliders());

  // Re-init when the section is added/reloaded in the theme editor
  document.addEventListener('shopify:section:load', (event) => {
    initSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.mh-slider').forEach((sliderEl) => {
      sliderEl.mhInstance?.destroy();
    });
  });

  // In case script runs after DOMContentLoaded already fired
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initSliders();
  }
})();
